module.exports = __webpack_public_path__ + "static/media/moons_pago_efectivo_oxxo.fd758139.svg";